// Module
var code = `<div class="bid-spread-ask-row" style="{{>visibility}}">

    {{#if snapshotVisible || delayedVisible}}
    <div class="js-delayed-snp">
        <div class="js-delayed" style="display: {{delayedVisible ? 'flex':'none'}};">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#delayedData"></use>
            </svg>
            {{delayedText}}
        </div>

        <div class="js-snp-container">
            <div class="js-snp {{snapshotBtnDisabled ? 'disabled':''}}" as-tooltip="snapshotBtnTooltip"
                 style="display: {{snapshotVisible ? 'flex':'none'}};" on-click="OnGetSnapshotClick">
                <svg>
                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#getSnapshot"></use>
                </svg>
                {{snapshotText}}
            </div>
        </div>
    </div>
    {{/if}}

    <div class="bid-spread-ask-container">
        <div class-bid="1" class-bid-color="!reverseView" class-ask-color="reverseView">
            {{>side bid}}
        </div>

        <div class="spread">{{spread || NA}}</div>

        <div class-ask="1" class-ask-color="!reverseView" class-bid-color="reverseView">
            {{>side ask}}
        </div>
    </div>
</div>

{{#partial side}}
{{#if !this}}
<span>{{~/NA}}</span>
{{else}}
{{this}}
{{/if}}
{{/partial}}`;
// Exports
export default code;